import { render, staticRenderFns } from "./PolicyInitiativeDetailsComparison.vue?vue&type=template&id=4416e5a0&scoped=true&"
import script from "./PolicyInitiativeDetailsComparison.vue?vue&type=script&lang=js&"
export * from "./PolicyInitiativeDetailsComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416e5a0",
  null
  
)

export default component.exports